module.exports = __webpack_public_path__ + "static/media/intro-poster.00c24eff.jpg";